var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.18 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 139") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.15,61.81a1.69,1.69,0,0,0,2.39-.27,1.72,1.72,0,0,0-.27-2.4,46.59,46.59,0,0,1-3.91-3.53L4.8,42.94,17.74,29.89A45.52,45.52,0,0,1,65,18.71a1.7,1.7,0,0,0,2.15-1.08,1.72,1.72,0,0,0-1.07-2.17,48.87,48.87,0,0,0-50.71,12L0,42.94,14.95,58A50.2,50.2,0,0,0,19.15,61.81ZM85.23,27.47a49.91,49.91,0,0,0-7.45-6.19,1.69,1.69,0,0,0-2.35.47,1.72,1.72,0,0,0,.46,2.38,46.46,46.46,0,0,1,6.95,5.77L95.38,42.55,82.43,55.6a46,46,0,0,1-48.1,10.88,1.69,1.69,0,0,0-2.17,1,1.72,1.72,0,0,0,1,2.19,48.77,48.77,0,0,0,16.59,2.9A49.42,49.42,0,0,0,84.83,58l15.34-15.48Zm-33.42,35a19.34,19.34,0,0,1-10.3-3,1.69,1.69,0,0,0-2.34.55,1.72,1.72,0,0,0,.54,2.36,22.69,22.69,0,0,0,12.09,3.48,23.15,23.15,0,0,0,19-35.94,1.69,1.69,0,0,0-2.35-.47A1.72,1.72,0,0,0,68,31.85,19.72,19.72,0,0,1,51.81,62.46Zm0-39.36a19.35,19.35,0,0,1,9.93,2.74,1.69,1.69,0,0,0,2.32-.6,1.72,1.72,0,0,0-.6-2.34,22.74,22.74,0,0,0-11.66-3.22A23.15,23.15,0,0,0,31.24,53a1.69,1.69,0,0,0,2.27.78,1.72,1.72,0,0,0,.78-2.29A19.72,19.72,0,0,1,51.81,23.1ZM92.66.5a1.68,1.68,0,0,0-2.4,0L11.38,80.08a1.72,1.72,0,0,0,0,2.42,1.69,1.69,0,0,0,2.4,0L92.66,2.92A1.72,1.72,0,0,0,92.66.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.5748e25b07e779833fa37a315f834285.svg";
export { ForwardRef as ReactComponent };